import HeartImage from '../assets/Onboarding/HeartImage.svg';
import { RxCross1 } from 'react-icons/rx';
import { Button } from './ui/button';
import { Dialog, DialogClose, DialogContent } from './ui/dialog';

type SeriousSymptomsModaleProps = {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
};

export const SeriousSymptomsModale = ({
  isOpen,
  setIsOpen,
}: SeriousSymptomsModaleProps) => {
  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogContent className="max-h-[95vh] nsm:w-[452px]">
        <div className="flex flex-col flex-1 min-h-0 px-6 py-5">
          <DialogClose
            className="absolute top-3 right-2 h-8 rounded-lg p-1 mr-2 cursor-pointer focus:ring-0 focus:outline-hidden focus:border-transparent hover:bg-gray-100"
            onClick={() => setIsOpen(false)}
          >
            <RxCross1 className="h-5 w-5 text-gray-600 stroke-[0.2]" />
          </DialogClose>
          <div className="flex flex-col justify-start flex-1 min-h-0 overflow-y-auto no-scrollbar">
            <img
              src={HeartImage}
              alt="Coeur"
              className="size-32 mb-6 mx-auto shrink-0"
            />
            <div className="flex flex-col gap-3">
              <p className="text-2xl font-medium">
                C&apos;est quoi un symptôme grave ?
              </p>
              <p className="leading-5.5">
                Composez le 15 pour toute situation d&apos;urgence ou si vous
                présentez un des symptômes suivants :
              </p>
              <ul className="list-disc pl-6 space-y-3 leading-5.5">
                <li>Difficultés à respirer</li>
                <li>Douleur ou pression thoracique</li>
                <li>
                  Signes d&apos;AVC – paralysie du visage, faiblesse d&apos;un
                  membre, difficultés à parler, mal de tête intense et soudain,
                  etc.
                </li>
                <li>
                  Crise convulsive – mouvements brusques et involontaires du
                  corps
                </li>
                <li>Malaise ou perte de connaissance</li>
                <li>
                  Allergie sévère – crise d&apos;asthme ou gonflements du visage
                  ou de la gorge
                </li>
                <li>
                  Douleur ou traumatisme oculaire avec trouble de la vision
                </li>
                <li>Blessure grave ou avec un saignement persistant</li>
                <li>Pensées suicidaires (appeler le 3114)</li>
              </ul>
            </div>
          </div>
          <div className="flex flex-col w-full items-center nsm:px-2 pt-4 shrink-0">
            <Button
              variant="ctaPrimary"
              size="lg"
              onClick={() => setIsOpen(false)}
            >
              Compris
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
